import en from './getVaroAppStrings.en';

export default {
  en,
};
